<template>
  <div>
    <img width="600px" src="../assets/logo.svg">
    <h1>Hola {{name}}, bienvenido al nuevo framework de Tecnoclub</h1>
    <br><br>
    <h1><router-link to="/assist/admin">Acceder al Assist Control</router-link></h1>
  </div>
</template>

<script>
    export default {
        name: 'Home',
        data () {
            return {
                name: 'Jordi'
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
</style>